// extracted by mini-css-extract-plugin
module.exports = {"row":"_64dbad83","top":"_8bdc2522","bottom":"_8e03e406","center":"_12ea65e2"};